
import Vue from 'vue'

export default Vue.extend({
  name: 'TYPE_ONE_INTRO',
  data () {
    return {
      version: process.env.VUE_APP_VERSION // Application version
    }
  }
})
